import { Empty } from "antd";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import React from "react";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  LineController
);

const RevenueChart = ({
  labels = [],
  permanenceData = [],
  faturamento_data = [],
  conversionData = [],
  conversionLabel = "Conversão (%)",
}) => {
  if (!labels || !Array.isArray(labels) || labels.length === 0) {
    return (
      <Empty
        description="Não há dados de faturamento disponíveis para o período selecionado"
        style={{ margin: "20px 0" }}
      />
    );
  }

  const permanenceMap = new Map();
  if (permanenceData && Array.isArray(permanenceData)) {
    permanenceData.forEach((item) => {
      if (item && item.date && typeof item.occupation === "number") {
        permanenceMap.set(item.date, item.occupation);
      }
    });
  }

  const data = {
    labels,
    datasets: [],
  };

  if (
    faturamento_data &&
    Array.isArray(faturamento_data) &&
    faturamento_data.length > 0
  ) {
    data.datasets.push({
      type: "bar",
      label: "Faturamento (R$)",
      data: faturamento_data,
      borderColor: "rgba(107, 114, 128, 1)",
      backgroundColor: "rgba(107, 114, 128, 0.85)",
      borderWidth: 1,
      yAxisID: "y-axis-faturamento",
      order: 3,
    });
  }

  const peopleData = labels.map((date) => permanenceMap.get(date) || 0);

  data.datasets.push({
    type: "line",
    label: "Atenção (min)",
    data: peopleData,
    backgroundColor: "rgba(34, 139, 34, 0.15)",
    borderColor: "rgba(34, 139, 34, 1)",
    borderWidth: 2,
    pointRadius: 2,
    pointHoverRadius: 4,
    fill: false,
    tension: 0.25,
    yAxisID: "y-axis-permanencia",
    order: 1,
  });

  const conversionSeries =
    conversionData && Array.isArray(conversionData) ? conversionData : [];

  if (conversionSeries.length > 0) {
    data.datasets.push({
      type: "line",
      label: conversionLabel,
      data: conversionSeries,
      borderColor: "#1f77b4",
      backgroundColor: "rgba(31, 119, 180, 0.15)",
      borderWidth: 2,
      pointRadius: 2,
      pointHoverRadius: 4,
      yAxisID: "y-axis-conversao",
      fill: false,
      tension: 0.25,
      order: 2,
    });
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          generateLabels: (chart) => {
            const defaultGenerateLabels =
              ChartJS.defaults.plugins.legend.labels.generateLabels;
            const labels = defaultGenerateLabels(chart);

            return labels.map((item) => {
              const isVisible = chart.isDatasetVisible(item.datasetIndex);
              return {
                ...item,
                // Keep dataset toggle behavior but remove strikethrough rendering.
                hidden: false,
                fontColor: isVisible
                  ? "rgba(17, 24, 39, 0.92)"
                  : "rgba(17, 24, 39, 0.42)",
                fillStyle: isVisible
                  ? item.fillStyle
                  : "rgba(148, 163, 184, 0.32)",
                strokeStyle: isVisible
                  ? item.strokeStyle
                  : "rgba(148, 163, 184, 0.42)",
              };
            });
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Agregação (Data)",
        },
      },
      "y-axis-faturamento": {
        type: "linear",
        position: "left",
        title: {
          display: true,
          text: "Faturamento (R$)",
        },
        beginAtZero: true,
      },
      "y-axis-permanencia": {
        type: "linear",
        position: "right",
        title: {
          display: true,
          text: "Atenção (min)",
        },
        beginAtZero: true,
        grid: {
          drawOnChartArea: false,
        },
      },
      "y-axis-conversao": {
        type: "linear",
        position: "right",
        display: false,
        min: 0,
        beginAtZero: true,
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };

  return (
    <div style={{ height: "400px" }}>
      <Chart data={data} options={options} />
    </div>
  );
};

export default RevenueChart;
